import { useEffect, useContext, useState } from "react";
import { useReport } from "../../contexts/ReportContext";
import { NavigationContext } from "../../contexts/NavigationContext";
import { useUpdate } from "../.././contexts/UpdateContext";
import { StyledButton } from "../../components/styles/buttons/Buttons";
import {
  StyledFormWrapper,
  StyledTextArea,
  DescriptionSpan,
  StyledLabel,
  StyledParagraph,
  StyledFormDescription,
  StyledError,
} from "../../components/styles/form/Form";
import {
  StyledHeroHeadingThin,
  StyledSpanWord,
  StyledBoldHeader,
  StyledInfoText,
} from "../../components/styles/Typography/Typography";
import {
  StyledButtonOuter,
  StyledButtonInner,
  StyledHeroContainer,
} from "../../components/styles/containers/Containers";

const DescriptionView = () => {
  const { setCurrentViewHeading } = useUpdate();
  const { handelSetFormInfo, formState } = useReport();
  const { dispatch } = useContext(NavigationContext);
  const [showError, setShowError] = useState(false);
  const REGISTRATION_TYPE = process.env.REACT_APP_REGISTRATION_TYPE;
  useEffect(() => {
    document.title = "Felanmälan - Beskriv ärendet";
    setCurrentViewHeading(
      <StyledHeroContainer>
        <StyledHeroHeadingThin>
          <StyledSpanWord>Beskriv&nbsp;ärendet</StyledSpanWord>
        </StyledHeroHeadingThin>
        {REGISTRATION_TYPE === "external" && (
          <StyledInfoText>
            Lämna endast de uppgifter som är nödvändiga för att vi ska kunna
            hantera ditt ärende. Ditt ärende blir en allmän handling som på
            begäran kan komma att lämnas ut. Det kan även komma att ges ut till
            andra aktörer som ska hantera ärendet.
          </StyledInfoText>
        )}
      </StyledHeroContainer>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFormInfo = (e) => {
    handelSetFormInfo("description", e.target.value);
    setShowError(false);
  };
  const handleNextClick = () => {
    //console.log("desc", formState.description);
    if (!formState.description) {
      setShowError(true);
    } else {
      dispatch({ type: "next" });
    }
  };
  return (
    <>
      <StyledFormWrapper>
        <StyledFormDescription>
          <StyledParagraph>* = obligatoriskt</StyledParagraph>
          <StyledLabel htmlFor="Beskrivning">
            <StyledBoldHeader>
              Beskriv problemet eller din synpunkt
            </StyledBoldHeader>
            <DescriptionSpan> * </DescriptionSpan>
          </StyledLabel>
          <StyledTextArea
            id="Beskrivning"
            defaultValue={formState.description}
            onChange={handleFormInfo}
            aria-label="Fältet är obligatoriskt"
            aria-invalid={showError}
          />
          {showError && (
            <StyledError
              aria-live="assertive"
              aria-describedby="Beskrivning"
              id="errorValueMissing"
            >
              * En beskrivning saknas
            </StyledError>
          )}
        </StyledFormDescription>
      </StyledFormWrapper>
      <StyledButtonOuter>
        <StyledButtonInner>
          <StyledButton
            // disabled={!formState.description}
            onClick={() => {
              handleNextClick();
            }}
            aria-describedby="errorValueMissing"
          >
            Nästa steg
          </StyledButton>
          <StyledButton
            secondary
            onClick={() => {
              dispatch({ type: "previous" });
            }}
          >
            Tillbaka
          </StyledButton>
        </StyledButtonInner>
      </StyledButtonOuter>
    </>
  );
};

export default DescriptionView;
